export default {
	// Goal created by James Kirk
	text: "KR <a href='#' data-action='key-result'>{name}</a> created by {changedBy}",
};
